export default "__VITE_ASSET__DimqvROz__"